import React, { PureComponent, useState } from 'react';
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  BarChart,
  ReferenceLine,
  Scatter,
  LabelList
} from 'recharts';
import { useList, useTable } from "@pankod/refine-core";
import { useMe } from "context/MeContext";
import { useSelect } from '@pankod/refine-core';
import { useMemo, useEffect } from 'react';
import { css } from '@emotion/react';

export default function HraResponsesChart() {
  const { company } = useMe();
  const [questionId, setQuestionId] = useState<number | null>(null);

  const {data: dataHraResponseDistro} = useList({
    resource: "hra-response-distro",
    config: {
      filters: [
        {
          field: "employee_code",
          operator: "eq",
          value: company?.code,
        },
      ],
      pagination: {
        pageSize: 1000, 
        current: 1,
      },
      sort: [
        {        
          field: "question_id",
          order: "asc",
        }
      ]
    }
  })
  const hraResponse = dataHraResponseDistro?.data
  console.log("hra response", hraResponse)         

  const questions = useMemo(() => {
    const questionMap = new Map();
    hraResponse?.forEach(({ question_id, question_desc }) => {
      if (!questionMap.has(question_id)) {
        questionMap.set(question_id, question_desc);
      }
    });
    return Array.from(questionMap.entries()).map(([id, desc]) => ({
      id,
      desc,
    }));
  }, [hraResponse]);


  const chartData = useMemo(() => {
    if (!questionId) return [];

    const filtered = hraResponse?.filter((item) => item.question_id === questionId);

    const answerCounts: Record<string, number> = {};
    filtered?.forEach(({ answer_option, responses }) => {
      const count = typeof responses === "string" ? parseInt(responses) : responses;
      answerCounts[answer_option] = (answerCounts[answer_option] || 0) + count;
    });

    return Object.entries(answerCounts).map(([option, count]) => ({
      answer_option: option,
      responses: count,
    }));
  }, [questionId, hraResponse]);
  useEffect(() => {
    if (hraResponse && hraResponse.length > 0) {
      setQuestionId(hraResponse[0].question_id);
    }
  }, [hraResponse]);
  const sortedChartData = useMemo(() => {
    return [...chartData].sort((a, b) => a.answer_option.localeCompare(b.answer_option));
  }, [chartData]);
  return (
    <div style={{ width: '100%', padding: "50px 70px 50px 50px"}}>
      <div className="select-question" css={css`
          width: 95%;
          height: 100%;
          margin: auto;
        `}>
        <label htmlFor="question-select" css={css`font-weight: bold; font-size: 18px;`}>Select Question: </label>
        <select value={questionId ?? ''} onChange={(e) => setQuestionId(parseInt(e.target.value))} css={css`
          width: 100%;
          height: 100%;
          margin: 20px auto 50px auto;
          padding: 10px 20px;
        `}>
          {questions.map((q, index) => (
            <option key={q.id} value={q.id}>
              {index}. {q.desc}
            </option>
          ))}
        </select>
      </div>

      {questionId && chartData.length > 0 && (
        <div style={{ height: 350, minWidth: "100%" }}>
          <ResponsiveContainer>
            <BarChart data={sortedChartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="answer_desc" />
              <YAxis allowDecimals={false} />
              <Tooltip
                formatter={(value, name) => {
                  if (name === "responses") return [value, "Number of Responses"];
                  return [value, name];
                }}
              />
              <Legend
                payload={[
                  {
                    value: 'Number of Responses',
                    type: 'square',
                    color: '#055d83',
                  },
                ]}
              />
              <Bar dataKey="responses" fill="#055d83" barSize={100} >
                <LabelList dataKey="answer_option" position="bottom" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    {questionId && (
      <div css={css`margin-top: 40px; padding: 0 20px;`}>
        <h4>Answer Options Explanation</h4>
        <ul>
          {hraResponse
            ?.filter(item => item.question_id === questionId)
            .reduce((acc, curr) => {
              if (!acc.some(a => a.answer_option === curr.answer_option)) {
                acc.push({ answer_option: curr.answer_option, answer_desc: curr.answer_desc });
              }
              return acc;
            }, [] as { answer_option: string; answer_desc: string }[])
            .sort((a, b) => a.answer_option.localeCompare(b.answer_option))
            .map(({ answer_option, answer_desc }) => (
              <li key={answer_option}>
                <strong>{answer_option}:</strong> {answer_desc}
              </li>
            ))}
        </ul>
      </div>
    )}



      {/* Optional: handle empty result */}
      {questionId && chartData.length === 0 && (
        <p>No data available for the selected question.</p>
      )}
    </div>
  );
}   
